// [SECTION] PAGES
// [SECTION] CART LOAD/SAVE
// [SECTION] KS RUN

// [SECTION] PAGE HOME
// [SECTION] PAGE CART
// [SECTION] PAGE ORDER

// [SECTION] BREADCRUMBS

/*
TODO:
[ ] Email sent table
[ ] Resend order confirmation button

[ ] Account menu shop mobile friendly
[ ] Admin menu mobile friendly
[ ] CO2 toekenning van leverancier naar klant verplaatsbaar maken
[ ] Exact factuur aanmaken
[ ] Addres book for order proces
[ ] Proof of Delivery support

[ ] GPS location for when running inventory for locations

[ ] Delete images from gallery

[ ] Confirm order by mail?
[ ] Validate Create Order
[ ] Freeze order page in contents of cart?

[ ] Last activity tracking
[ ] Image upload should trim whitespace
[ ] Reconsile when cart exceeds stock available on the back end

*/
declare const $: any;
declare const QrScanner: any;
declare const ApexCharts: any;

// NOTE: when reordering or extending this enum also update the name arrays
enum ProductCategory {
    None,
    Toilet,
    WallHungToilet,
    Urinal,
    Sink,
    Fountain,
    Planchet,
    Mirror,
    Tap,
    Max
}

let product_category_names = [
    '',
    'Toiletpot',
    'Hangtoilet',
    'Urinoir',
    'Wastafel',
    'Fontein',
    'Planchet',
    'Spiegel',
    'Kraan',
];
console.assert(product_category_names.length === ProductCategory.Max);

let product_category_names_plural = [
    '',
    'Toiletpotten',
    'Hangtoiletten',
    'Urinoirs',
    'Wastafels',
    'Fonteinen',
    'Planchetten',
    'Spiegels',
    'Kranen',
];
console.assert(product_category_names_plural.length === ProductCategory.Max);

// Note: per category, must match ProductCategory enum
// NOTE: order and index of brands matter, stored in db
let brand_options_sanitary = [
    'Geberit', 'Sphinx', 'Laufen', 'Ideal Standard', 'JIKA', 'Venlo', 'Allia', 'Pozzi Ginori',
    'VitrA', 'Gena', 'Dune', 'Villeroy & Boch', 'Plieger', 'Merkloos',
];
let brand_options = [
    [],
    brand_options_sanitary,
    brand_options_sanitary,
    brand_options_sanitary,
    brand_options_sanitary,
    brand_options_sanitary,
    [],
];

// NOTE: when reordering or extending this enum also update the number and name arrays
enum PropertyType {
    None,
    Brand,
    Width,
    Length,
    Depth,
    Height,
    ToiletModel,
    ToiletDrainType,
    ToiletDrainHeight,
    ToiletFlushType,
    ToiletRimlessFlush,
    UrinalInlet,
    SinkTapHole,
    SinkForm,
    SinkEdgeWidth,
    PlanchetMaterial,
    Max
}

const property_type_names = [
    '',
    'Merk',
    'Breedte',
    'Lengte',
    'Diepte',
    'Hoogte',
    'Model',
    'Plaats afvoer',
    'Afvoer hoogte',
    'Spoelvorm',
    'Spoelrand',
    'Aansluiting',
    'Kraan plek',
    'Vorm',
    'Rand',
    'Materiaal',
];
console.assert(property_type_names.length === PropertyType.Max);

const property_type_sort_val = [
    0,
    10,  // Brand
    20,  // Width
    30,  // Length
    40,  // Depth
    50,  // Height
    60,  // Model
    70,  // DrainType
    80,  // DrainHeight
    90,  // FlushType
    100, // RimlessFlush
    110, // UrinalInlet
    120, // SinkTapHole
    130, // SinkForm
    140, // SinkEdgeWidth
    150, // PlanchetMaterial
];
console.assert(property_type_sort_val.length === PropertyType.Max);

const prop_type_opts = [
    null,
    null,
    null,
    null,
    null,
    null,
    ['C', 'D'],
    ['PK', 'AO'],
    null,
    ['Vlak', 'Diep'],
    ['Ja', 'Nee'],
    ['Boveninlaat', 'Achterinlaat'],
    ['Links', 'Midden', 'Rechts', 'Zonder'],
    ['Halfrond', 'Rechthoekig', 'Rond', 'Ovaal', 'Overig'],
    ['Smal', 'Breed'],
    ['Keramiek', 'Kunststof'],
];
console.assert(prop_type_opts.length === PropertyType.Max);

function get_property_options(category: ProductCategory, type: PropertyType): string[] {
    return type === PropertyType.Brand ? brand_options[category] : prop_type_opts[type];
}

const prop_type_units = [
    '',
    '',
    'cm',
    'cm',
    'cm',
    'cm',
    '',
    '',
    'cm',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
];
console.assert(prop_type_units.length === PropertyType.Max);

const prop_type_labeled = [
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
];
console.assert(prop_type_labeled.length === PropertyType.Max);

// TODO: move to portal.ts?
const category_prop_types = [
    // None
    [],
    // Toilet
    [
        PropertyType.Brand, PropertyType.ToiletModel, PropertyType.Height, 
        PropertyType.ToiletFlushType, PropertyType.ToiletDrainType, PropertyType.ToiletDrainHeight
    ],
    // Wall-hung toilet
    [
        PropertyType.Brand, PropertyType.Width, PropertyType.Depth, PropertyType.Height,
        PropertyType.ToiletFlushType, PropertyType.ToiletRimlessFlush,
    ],
    // Urinal
    [
        PropertyType.Brand, PropertyType.Width, PropertyType.Height, PropertyType.Depth, PropertyType.UrinalInlet,
    ],
    // Sink
    [
        PropertyType.Brand, PropertyType.Width, PropertyType.SinkTapHole, PropertyType.SinkForm, PropertyType.SinkEdgeWidth],
    // Fontain
    [PropertyType.Brand, PropertyType.Width, PropertyType.SinkTapHole, PropertyType.SinkForm, PropertyType.SinkEdgeWidth],
    // Planchet
    [PropertyType.PlanchetMaterial, PropertyType.Length, PropertyType.Depth],
    // Mirror,
    [],
    // Tap,
    [],
];
console.assert(category_prop_types.length === ProductCategory.Max);


class ProductProperty {
    id: number;
    type: number;
    value: number;
    productId: number;
}

class ProductImage {
    id: number;
    sortIndex: number;
}

class Product {
    id = 0;
    category = ProductCategory.None;
    stock = 0;
    price = 0;
    weight = 0;
    co2PerKg = 0;
    name = '';
    desc = '';
    imageId = 0;
    images: ProductImage[] = [];
    hidden = false;
    archived = false;
    dateCreated = new Date();
    dateUpdated = new Date();
    properties: ProductProperty[] = [];
}


// Rounds to 1 decimal
function total_co2_formatted(co2: number) { return Math.round(co2 * 10) / 10; }


// [SECTION] PAGES
namespace Page {
    export const Login = {
        path: '/login',
        proc: page_login,
    };
    export const Register = {
        path: '/register',
        proc: page_register,
    };
    export const RequestPasswordReset = {
        path: '/password-reset-request',
        proc: page_password_reset_request,
    };
    export const PasswordReset = {
        path: '/password-reset',
        proc: page_password_reset,
    };
    export const Confirm_Email = {
        path: '/email-confirm',
        proc: page_confirm_email,
    };
    export const Order = {
        path: '/bestellen',
        proc: page_order,
    };
    export const Cart = {
        path: '/winkelwagen',
        proc: page_cart,
    };
    export const Shop = {
        path: '',
        proc: page_shop,
    };
    export const Legacy = {
        path: '/winkeloverzicht',
        proc: page_shop,
    }
};

let page = Page.Shop;


let screen_sm = false;
let screen_md = false;
let screen_lg = false;
let screen_compact = false;
let screen_sm_width = 576;
let screen_md_width = 768;
let screen_lg_width = 992;
let prev_window_inner_width = 0;


// [SECTION] CART LOAD/SAVE
let cart: { productId: number, count: number }[] = [];

function load_cart() {
    let str = window.localStorage.getItem('cart');
    if (str) {
        let stored = JSON.parse(str);
        let delta = Date.now() - stored.date_ms;
        if (delta < 1000 * 60 * 60 * 24 && Array.isArray(stored.items)) {
            cart.length = 0;
            cart.push(...stored.items);
        }
    }
}

function save_cart() {
    if (cart.length) {
        window.localStorage.setItem('cart', JSON.stringify({
            version: 1,
            date_ms: Date.now(),
            items: cart
        }));
    } else {
        window.localStorage.removeItem('cart');
    }
}

enum ClaimTypes {
    IsImpersonating = 'is_impersonating',
    UserData = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata',
}

class User {
    id: number;
    username: string;

    email: string;
    email_confirmed: boolean;
    phone_nr: string;
    organization_id: number;

    date_created: Date;
    date_last_access: Date;

    roles: string[] = [];
    claims: { type: ClaimTypes, value: string }[] = [];

    is_admin: boolean;
    is_staff: boolean;
}

let user = new User();
let search_params = new URLSearchParams(window.location.search);

let is_printing = false;

// [SECTION] KS RUN
ks.run(function () {
    prev_window_inner_width = window.innerWidth;
    screen_sm = window.innerWidth < screen_sm_width;
    screen_md = window.innerWidth < screen_md_width;
    screen_lg = window.innerWidth < screen_lg_width;
    screen_compact = screen_sm || screen_md;

    if (ks.first_time_ever()) {
        load_cart();

        window.addEventListener('storage', function (ev) {
            if (ev.key === 'cart') {
                load_cart();
                ks.refresh();
            }
        });

        window.addEventListener('resize', function (ev) {
            if (window.innerWidth < screen_sm_width && prev_window_inner_width >= screen_sm_width ||
                window.innerWidth >= screen_sm_width && prev_window_inner_width < screen_sm_width ||
                window.innerWidth < screen_md_width && prev_window_inner_width >= screen_md_width ||
                window.innerWidth >= screen_md_width && prev_window_inner_width < screen_md_width ||
                window.innerWidth < screen_lg_width && prev_window_inner_width >= screen_lg_width ||
                window.innerWidth >= screen_lg_width && prev_window_inner_width < screen_lg_width) {
                ks.refresh();
            }
        });

        window.addEventListener('beforeprint', function () {
            is_printing = true;
            ks.refresh();
        });

        window.addEventListener('afterprint', function () {
            is_printing = false;
            ks.refresh();
        });
    };

    let page_depth = -1;
    let pathname = window.location.pathname.toLowerCase();
    let parameters = '';
    for (let key in Page) {
        let p: { path: string, proc: () => void, public: boolean } = Page[key];
        let depth = 0;
        for (let i = 0; i < p.path.length; ++i) {
            depth += p.path[i] === '/' ? 1 : 0;
        }
        if (pathname.indexOf(p.path) === 0 && depth > page_depth) {
            page = p
            page_depth = depth;
            parameters = decodeURIComponent(pathname.substring(p.path.length + 1));
        }
    }

    let i_category = 0;
    let parts = parameters.split('/');
    if (parts.length >= 2) {
        if (parts[0] === 'c') {
            for (let i = 1; i < product_category_names_plural.length; ++i) {
                if (case_insensitive_comp.compare(parts[1], product_category_names_plural[i]) === 0) {
                    i_category = i;
                    break;
                }
            }
        }
    }

    /*
    bg option:
    background: rgb(249, 253, 250);
    border-bottom: 1px solid #e3f2ff;
    */
    if (page != Page.Login && page != Page.Register && page != Page.RequestPasswordReset && 
        page != Page.PasswordReset && page != Page.Confirm_Email) {
        let impersonating = user && user.claims.some(c => c.type === ClaimTypes.IsImpersonating && c.value === '1');
        if (impersonating) {
            ks.group('impersonation', 'bg-danger text-center py-2', function () {
                ks.text('Je bent ingelogd als ' + user.username + '. ', 'text-white d-inline');
                ks.set_next_item_class_name('position-absolute text-white');
                ks.anchor('Beëindig sessie', '/stop-impersonation').style.right = '16px';
            });
        }
        ks.nav_bar('nav', 'navbar-expand-md bg-light shadow-sm', function () {
            ks.group('container', 'container my-1', function () {
                ks.group('row', 'row flex-grow-1 align-items-center', function () {
                    navbar.call(this, i_category);
                });
            });
        });
    }

    ks.group(page.path, 'container my-4', function () {
        page.proc.call(this, parameters);

        // primary color: #33a78c

        // blue #4BB3FD #4062BB #1768AC #0E6BA8 72A1E5 0496FF 4BB3FD 027BCE
        // light blue # DDF2EB EDF5FC BFD7EA
        // light green #73baa5 #65ab8a
        // danger #EF476F #FC440F FF6B6B
        // warning F3CA40 E9D758 FFC914
        // light bg F7FFF6 DFE4EB F8F8F7
        // dark bg 1D1A05 272D2D 484A47 463F3A 2A3D45 022F40 052F5F
    });
});

let case_insensitive_comp = new Intl.Collator(undefined, { sensitivity: 'base' });

let nr_fmt = new Intl.NumberFormat('nl-NL', {
    maximumFractionDigits: 2,
});

let co2_nr_fmt = new Intl.NumberFormat('nl-NL', {
    maximumFractionDigits: 1,
});

let euro_fmt = new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
});

let date_fmt = new Intl.DateTimeFormat('nl-NL', {
    year: '2-digit',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
});

let date_only_fmt = new Intl.DateTimeFormat('nl-NL', {
    year: '2-digit',
    month: '2-digit',
    day: '2-digit',
});

function date_input_format (d: Date) {
    let month = 1 + d.getMonth();
    let day = d.getDate();
    return d.getFullYear() + (month < 10 ? '-0' : '-') + month + (day < 10 ? '-0' : '-') + day;
};


function navbar(i_category: number) {
    let state = ks.local_persist('state', {
        menu_expand: false,
    });

    let compact = screen_sm || screen_md;
    ks.set_next_item_class_name('d-flex col-lg-2 col-md-3 col-sm-12');
    ks.group('bar', compact ? 'align-content-between align-items-center' : 'd-flex', function () {
        if (compact) {
            ks.set_next_item_class_name('py-2 pl-1 pr-2 text-nowrap');
            ks.anchor('filter', '', function () {
                ks.icon(state.menu_expand ? 'fad fa-bars' : 'fas fa-bars').style.fontSize = '1.5rem';
            });
            ks.is_item_clicked(function () {
                state.menu_expand = !state.menu_expand;
                ks.refresh();
                return false;
            });
        }

        ks.set_next_item_class_name('mx-auto mr-md-2 ml-md-0 mb-1 mb-md-0');
        ks.anchor('home', '/', function () {
            ks.image('/img/reuse_logo.svg', undefined, 30, '', 'Re-Use');
        }).style.padding = compact ? '4px 0 4px 0' : '6px 0 4px 0';
        ks.is_item_clicked(function () {
            ks.navigate_to('Home', '/');
            return false;
        });

        if (compact) {
            if (user.id) {
                ks.set_next_item_class_name('d-flex flex-row ml-2 mr-2 align-items-center');
                ks.anchor('User', '/portal', function () {
                    ks.icon('far fa-user').style.fontSize = '1.5rem';
                });

                ks.set_next_item_class_name('d-flex flex-row ml-2 mr-3 align-items-center');
                ks.anchor('Dashboard', '/portal', function () {
                    ks.icon('far fa-chart-line').style.fontSize = '1.75rem';
                }).title = 'Dashboard';
            } else {
                ks.set_next_item_class_name('ml-2 mr-2 mb-1');
                ks.anchor('Inloggen', Page.Login.path);
                ks.is_item_clicked(function () {
                    search_params.set('ReturnUrl', page.path);
                    ks.navigate_to('Login', Page.Login.path + '?ReturnUrl=' + page.path);
                    return false;
                });
            }

            ks.set_next_item_class_name('pl-2 pr-1 text-nowrap');
            ks.anchor('cart', '/winkelwagen', function () {
                ks.icon('far fa-shopping-cart').style.fontSize = '1.5rem';
                if (cart.length) {
                    ks.text('' + cart.length, 'badge badge-primary align-top mt-1 ml-1');
                }
            });
            ks.is_item_clicked(function () {
                ks.navigate_to('Winkelwagen', '/winkelwagen');
                return false;
            });
        }
    });

    if (compact && state.menu_expand) {
        ks.group('mobile menu', 'col-12 my-1 mx-n3 flex-grow-1 text-center', function () {
            for (let i = 1; i < product_category_names_plural.length; ++i) {
                let url = '/c/' + product_category_names_plural[i].toLowerCase();
                ks.set_next_item_class_name('d-block py-2 border-top' + (i_category === i ? ' bg-primary text-white' : ''));
                ks.anchor(product_category_names_plural[i], url);
                ks.is_item_clicked(function () {
                    ks.navigate_to(product_category_names_plural[i], url);
                    return false;
                });
            }
        });
    }

    let el_search = ks.group('search', 'flex-grow-1 align-items-center', function () {
        ks.group('search', 'input-group', function () {
            ks.set_next_item_class_name('border-right-0');
            ks.input_text('search', search_params.get('search') || '', 'Waar bent u naar op zoek?', function (str) {
                run_product_filter = true;
                search_params.set('search', str);
                ks.refresh();
            });
            ks.group('btn', 'input-group-append', function () {
                let search_field = search_params.get('search');
                ks.button_container('close', function () {
                    ks.icon(search_field ? 'fal fa-times' : 'far fa-search');
                }, 'outline-primary');
                if (search_field) {
                    ks.is_item_clicked(function () {
                        run_product_filter = true;
                        search_params.set('search', '');
                        ks.refresh();
                    });
                }
            });
        });
    });
    el_search.style.padding = '0 15px';
    el_search.style.maxWidth = '680px';

    if (!compact) {
        ks.unordered_list('nav', 'navbar-nav justify-content-end align-items-center col-auto ml-auto', function () {
            if (user.id) {
                ks.group('user', 'dropdown', function () {
                    ks.set_next_item_class_name('d-flex flex-row mr-2 align-items-center');
                    ks.anchor('User', '/portal', function () {
                        ks.group('welcome', 'text-center mr-2', function () {
                            ks.text('Welkom');
                            ks.text(user.username, 'font-weight-bold text-nowrap');
                        }).style.fontSize = '0.8rem';
                        ks.icon('far fa-user').style.fontSize = '1.5rem';
                    }).setAttribute('data-toggle', 'dropdown');
                    ks.is_item_clicked(function () {
                        return false;
                    });

                    ks.group('dropdown', 'dropdown-menu', function () {
                        ks.set_next_item_class_name('dropdown-item');
                        ks.anchor('Dashboard', '/portal');

                        ks.set_next_item_class_name('dropdown-item');
                        ks.anchor('Bestellingen', '/portal/orders');

                        ks.set_next_item_class_name('my-1');
                        ks.separator();

                        ks.set_next_item_class_name('dropdown-item');
                        ks.anchor('Uitloggen', '/logout');
                    });

                });

                ks.set_next_item_class_name('d-flex flex-row ml-2 mr-3 align-items-center');
                ks.anchor('Dashboard', '/portal', function () {
                    ks.icon('far fa-chart-line').style.fontSize = '1.75rem';
                }).title = 'Dashboard';
            } else {
                ks.set_next_item_class_name('ml-2 mr-3 mb-1');
                ks.anchor('Inloggen', Page.Login.path);
                ks.is_item_clicked(function () {
                    search_params.set('ReturnUrl', page.path);
                    ks.navigate_to('Login', Page.Login.path + '?ReturnUrl=' + page.path);
                    return false;
                });
            }

            ks.set_next_item_class_name('pl-2 text-nowrap');
            ks.anchor('cart', '/winkelwagen', function () {
                ks.icon('far fa-shopping-cart').style.fontSize = '1.5rem';
                if (cart.length) {
                    ks.text('' + cart.length, 'badge badge-primary align-top mt-1 ml-1');
                }
            }).title = 'Winkelwagen';
            ks.is_item_clicked(function () {
                ks.navigate_to('Winkelwagen', '/winkelwagen');
                return false;
            });
        }).style.paddingLeft = '15px';
    }
}


function page_login(parameters: string) {
    if (user.id) {
        ks.navigate_to('Logged in', search_params.get('ReturnUrl') || '/');
        return;
    }

    let state = ks.local_persist('state', {
        error: false,
        invalid: false,
        nolicense: false,
        migrated: false,
        migration_error: false,
        password_confirm: '',
    });

    if (ks.is_new_scope()) {
        state.error = false;
        state.invalid = false;
        state.nolicense = false;
        state.migrated = false;
        state.migration_error = false;
    }

    ks.on_scope_removal(function () {
        state.password_confirm = '';
    });

    let el_card = ks.group('login', 'card mx-auto mb-2', function () {
        ks.group('body', 'card-body', function () {
            ks.group('logo', 'mb-3', function () {
                ks.anchor('home', '/', function () {
                    ks.image('/img/reuse_logo.svg', undefined, undefined, 'img-fluid', 'Re-Use').style.maxHeight = '45px';
                });
                ks.is_item_clicked(function () {
                    ks.navigate_to('Home', '/');
                    return false;
                });
            });

            ks.h3('Inloggen', 'mb-3');

            if (state.migrated) {
                ks.text('U ontvangt binnen enkele minuten een link om uw e-mailadres te bevestigen voor dit nieuw systeem, na de bevestiging kunt u weer inloggen.');
                return;
            }

            ks.set_next_item_class_name('mb-3');
            ks.form('login', '', false, function () {
                let login = ks.local_persist('login', {
                    email: '',
                    password: '',
                    rememberMe: true,
                });
                let show_validation = this._ks_info.show_validation;

                ks.input_text('email', login.email, 'Email of gebruikersnaam', function (str) {
                    login.email = str;
                });

                let state_pass = ks.local_persist('show pass', { show: false });
                ks.group('password', 'input-group', function () {
                    if (show_validation && state.migration_error && 
                        (login.password.length < 12 || login.password !== state.password_confirm)) {
                        ks.set_next_item_class_name('is-invalid');
                    }
                    ks.input_password('password', login.password, 'Password', function (str) {
                        login.password = str;
                    }).type = state_pass.show ? 'text' : 'password';

                    ks.group('show', 'input-group-append border-left mb-3', function () {
                        let btn = ks.button_container('btn', function () {
                            ks.icon('fa fa-eye');
                        }, state_pass.show ? 'primary' : 'outline-primary');
                        btn.type = 'button';
                        btn.style.border = '1px solid #ced4da';
                    }).style.height = 'calc(1.5em + 0.75rem + 2px)';
                    ks.is_item_clicked(function () {
                        state_pass.show = !state_pass.show;
                        ks.refresh(this);
                    });
                });

                if (state.migration_error) {
                    ks.group('password confirm', 'input-group', function () {
                        if (show_validation &&
                            (login.password !== state.password_confirm || state.password_confirm.length < 12)) {
                            ks.set_next_item_class_name('is-invalid');
                        }
                        ks.input_password('password', state.password_confirm, 'Password', function (str) {
                            state.password_confirm = str;
                        }).type = state_pass.show ? 'text' : 'password';

                        ks.group('show', 'input-group-append border-left mb-3', function () {
                            let btn = ks.button_container('btn', function () {
                                ks.icon('fa fa-eye');
                            }, state_pass.show ? 'primary' : 'outline-primary');
                            btn.type = 'button';
                            btn.style.border = '1px solid #ced4da';
                        }).style.height = 'calc(1.5em + 0.75rem + 2px)';
                        ks.is_item_clicked(function () {
                            state_pass.show = !state_pass.show;
                            ks.refresh();
                        });

                        if (show_validation && (login.password !== state.password_confirm || login.password.length < 12)) {
                            ks.text(login.password.length < 12 ? 'Wachtwoord moet minstens 12 tekens lang zijn.' : 'Wachtwoorden komen niet overeen.', 'invalid-feedback mt-n2 mb-3');
                        }
                    });

                    ks.text('Dit wachtwoord voldoet niet meer aan de nieuwe eisen, u kunt een nieuw wachtwoord opgeven.', 'alert alert-info mb-3');
                }
                if (state.error) {
                    ks.text('Er is helaas iets misgegaan, probeer het opnieuw. Neem contact met ons op via ' + o_e_combine('info') + ' als het probleem aanhoudt.', 'alert alert-danger mb-3');
                }
                if (state.invalid) {
                    ks.text('Helaas kon je niet worden ingelogd. Controleer je gegevens en probeer het opnieuw.', 'alert alert-danger mb-3');
                }
                if (state.nolicense) {
                    ks.text('Er is helaas geen actieve licentie gevonden. Neem contact met ons op via ' + o_e_combine('info') + '.', 'alert alert-danger mb-3');
                }

                ks.checkbox('Onthoud mij', login.rememberMe, function (checked) {
                    login.rememberMe = checked;
                });

                ks.button('Inloggen', ks.no_op);

                if (ks.current_form_submitted()) {
                    if (!this.getElementsByClassName('is-invalid').length) {
                        state.error =false;
                        state.invalid = false;
                        state.nolicense = false;

                        xhr_send('POST', Page.Login.path + '?ReturnUrl=' + search_params.get('ReturnUrl'), login).then(function () {
                            xhr_send('GET', '/me').then(function (response: User) {
                                Object.assign(user, response);
                                login.password = '';
                                let returnUrl = search_params.get('ReturnUrl') || '/';
                                if (returnUrl.length > 1 && returnUrl[returnUrl.length - 1] === '/') {
                                    returnUrl = returnUrl.substring(0, returnUrl.length - 1);
                                }

                                let reload = true;
                                for (let key in Page) {
                                    let p: { path: string, proc: () => void, public: boolean } = Page[key];
                                    if (p.path.startsWith(returnUrl)) {
                                        reload = false;
                                        ks.navigate_to('Logged in', returnUrl);
                                        break;
                                    }
                                }
                                if (reload) { window.location.href = returnUrl; }
                            });
                        }).catch(function (reason: XHR_Reason) {
                            if (reason.status === 428) {
                                state.migrated = true;
                            } else if (reason.status === 401) {
                                state.invalid = true;
                            } else if (reason.status === 402) {
                                state.nolicense = true;
                            } else if (reason.status === 422) {
                                state.migration_error = true;
                            } else {
                                state.error = true;
                            }
                            ks.refresh();
                        });
                        ks.unsubmit_current_form();
                    }
                }
            });

            ks.anchor('Wachtwoord vergeten?', Page.RequestPasswordReset.path);
            ks.is_item_clicked(function () {
                ks.navigate_to('Password reset', Page.RequestPasswordReset.path);
                return false;
            });
        });
    });
    el_card.style.maxWidth = '450px';
    el_card.style.marginTop = '8vh';
}

function page_register(parameters: string) {
    ks.navigate_to('Home', '/');
    return;

    //let el_card = ks.group('register', 'card mx-auto mb-2', function () {
    //    ks.group('body', 'card-body', function () {
    //        ks.group('logo', 'mb-3', function () {
    //            ks.anchor('home', '/', function () {
    //                ks.image('/img/reuse_logo.svg', undefined, undefined, 'img-fluid', 'Re-Use').style.maxHeight = '45px';
    //            });
    //            ks.is_item_clicked(function () {
    //                ks.navigate_to('Home', '/');
    //                return false;
    //            });
    //        });

    //        ks.h3('Registreren', 'mb-3');

    //        ks.form('register', '', false, function () {
    //            let register = ks.local_persist('login', {
    //                email: '',
    //                password: '',
    //                passwordConfirm: '',
    //            });

    //            ks.input_text('email', register.email, 'Email', function (str) {
    //                register.email = str;
    //            });

    //            ks.set_next_input_validation(register.password === register.passwordConfirm, '', '');
    //            ks.input_password('password', register.password, 'Password', function (str) {
    //                register.password = str;
    //            });

    //            ks.set_next_input_validation(register.password === register.passwordConfirm, '', '');
    //            ks.input_password('password confirm', register.passwordConfirm, 'Password', function (str) {
    //                register.passwordConfirm = str;
    //            });

    //            ks.button('Registreer', ks.no_op);

    //            if (ks.current_form_submitted()) {
    //                if (!this.getElementsByClassName('is-invalid').length) {
    //                    xhr_send('POST', '/register?ReturnUrl=/kaplah', register);
    //                    register.password = '';
    //                    register.passwordConfirm = '';
    //                    ks.unsubmit_current_form();
    //                    ks.refresh();
    //                }
    //            }
    //        });
    //    });
    //});
    //el_card.style.maxWidth = '450px';
    //el_card.style.marginTop = '8vh';
}


function page_password_reset() {
    let state = ks.local_persist('state', {
        password: '',
        password_confirm: '',
        reset: false,
        requested: false,
        error: false,
    });
    if (ks.is_new_scope()) {
        state.reset = false;
        state.requested = false;
    }

    let el_card = ks.group('pass reset', 'card mx-auto mb-2', function () {
        ks.group('body', 'card-body', function () {
            ks.group('logo', 'mb-3', function () {
                ks.anchor('home', '/', function () {
                    ks.image('/img/reuse_logo.svg', undefined, undefined, 'img-fluid', 'Re-Use').style.maxHeight = '45px';
                });
                ks.is_item_clicked(function () {
                    ks.navigate_to('Home', '/');
                    return false;
                });
            });

            if (state.reset) {
                ks.text('Uw wachtwoord is gewijzigd, u wordt binnen enkele seconde omgeleid naar de login pagina.', 'text-success');
                ks.set_timeout('reset timer', 5000, function () {
                    state.reset = false;
                    ks.navigate_to('Login', Page.Login.path);
                });
                return;
            }

            ks.h3('Wachtwoord wijzigen', 'mb-3');

            ks.form('reset', '', false, function () {
                ks.input_text('email', search_params.get('email'), 'Email', ks.no_op).disabled = true;

                let state_pass = ks.local_persist('show pass', { show: false });

                let show_validation = this._ks_info.show_validation;
                ks.group('password', 'input-group', function () {
                    if (show_validation && (state.password !== state.password_confirm || state.password.length < 12)) {
                        ks.set_next_item_class_name('is-invalid');
                    }
                    ks.input_password('password', state.password, 'Password', function (str) {
                        state.password = str;
                    }).type = state_pass.show ? 'text' : 'password';

                    ks.group('show', 'input-group-append border-left mb-3', function () {
                        let btn = ks.button_container('btn', function () {
                            ks.icon('fa fa-eye');
                        }, state_pass.show ? 'primary' : 'outline-primary');
                        btn.type = 'button';
                        btn.style.border = '1px solid #ced4da';
                    }).style.height = 'calc(1.5em + 0.75rem + 2px)';
                    ks.is_item_clicked(function () {
                        state_pass.show = !state_pass.show;
                        ks.refresh();
                    });
                });

                ks.group('password confirm', 'input-group', function () {
                    if (show_validation && (state.password !== state.password_confirm || state.password_confirm.length < 12)) {
                        ks.set_next_item_class_name('is-invalid');
                    }
                    ks.input_password('password', state.password_confirm, 'Password', function (str) {
                        state.password_confirm = str;
                    }).type = state_pass.show ? 'text' : 'password';

                    ks.group('show', 'input-group-append border-left mb-3', function () {
                        let btn = ks.button_container('btn', function () {
                            ks.icon('fa fa-eye');
                        }, state_pass.show ? 'primary' : 'outline-primary');
                        btn.type = 'button';
                        btn.style.border = '1px solid #ced4da';
                    }).style.height = 'calc(1.5em + 0.75rem + 2px)';
                    ks.is_item_clicked(function () {
                        state_pass.show = !state_pass.show;
                        ks.refresh();
                    });

                    if (show_validation && (state.password !== state.password_confirm || state.password.length < 12)) {
                        ks.text(state.password.length < 12 ? 'Wachtwoord moet minstens 12 tekens lang zijn.' : 'Wachtwoorden komen niet overeen.', 'invalid-feedback mt-n2 mb-3');
                    }
                });

                if (state.error) {
                    ks.text('Er is iets misgegaan, probeer het opnieuw. Neem contact met ons op als het probleem aanhoudt via ' + o_e_combine('info'), 'text-danger mb-3');
                };

                ks.button('Wijzig wachtwoord', ks.no_op).disabled = state.requested;

                if (ks.current_form_submitted()) {
                    if (!this.getElementsByClassName('is-invalid').length) {
                        state.requested = true;

                        xhr_send('POST', '/password-reset', {
                            email: search_params.get('email'),
                            password: state.password,
                            token: search_params.get('token'),
                        }).then(function (response) {
                            state.reset = true;
                            state.password = '';
                            state.password_confirm = '';
                        }).catch(function () {
                            state.error = true;
                        }).finally(function () {
                            state.requested = false;
                            ks.refresh();
                        });

                        ks.unsubmit_current_form();
                        ks.refresh();
                    }
                }
            });
        });
    });
    el_card.style.maxWidth = '450px';
    el_card.style.marginTop = '8vh';
}


function page_password_reset_request() {
    let el_card = ks.group('pass reset request', 'card mx-auto mb-2', function () {
        ks.group('body', 'card-body', function () {
            ks.group('logo', 'mb-3', function () {
                ks.anchor('home', '/', function () {
                    ks.image('/img/reuse_logo.svg', undefined, undefined, 'img-fluid', 'Re-Use').style.maxHeight = '45px';
                });
                ks.is_item_clicked(function () {
                    ks.navigate_to('Home', '/');
                    return false;
                });
            });

            ks.h3('Wachtwoord vergeten?', 'mb-3');

            ks.text('Geen probleem. Vul je e-mailadres in en ontvang binnen enkele minuten een link om je nieuwe wachtwoord in te stellen.', 'mb-4');

            ks.set_next_item_class_name('mb-3');
            ks.form('reset_password_request', '', false, function () {
                let state = ks.local_persist('state', {
                    email: '',
                    error: false,
                    requested: false,
                });
                if (ks.is_new_scope()) {
                    state.error = false;
                    state.requested = false;
                }

                if (state.error) {
                    ks.text('Er is helaas iets misgegaan, neem contact met ons op als dit probleem zich blijft voordoen.', 'text-danger text-center');
                } else if (state.requested) {
                    ks.text('U ontvangt binnen enkele minuten een email met een wachtwoord reset link.', 'text-success text-center');
                } else {
                    ks.input_text('email', state.email, 'Email', function (str) {
                        state.email = str;
                    });

                    ks.button('Reset link aanvragen', ks.no_op);
                }

                if (ks.current_form_submitted()) {
                    if (!this.getElementsByClassName('is-invalid').length) {
                        xhr_send('POST', '/password-reset-request', { email: state.email }).then(() => {
                            state.requested = true;
                            ks.refresh();
                        }).catch(function (reason: XHR_Reason) {
                            state.error = true;
                            ks.refresh();
                        });
                        ks.unsubmit_current_form();
                        ks.refresh();
                    }
                }
            });

            ks.anchor('Terug naar inloggen', Page.Login.path);
            ks.is_item_clicked(function () {
                ks.navigate_to('Login', Page.Login.path);
                return false;
            });
        });
    });
    el_card.style.maxWidth = '450px';
    el_card.style.marginTop = '8vh';
}


function page_confirm_email(parameters: string) {
    let success = search_params.get('status') === 'success';
    let el_card = ks.group('confirm email', 'card mx-auto mb-2', function () {
        ks.group('body', 'card-body', function () {
            ks.group('logo', 'mb-3', function () {
                ks.anchor('home', '/', function () {
                    ks.image('/img/reuse_logo.svg', undefined, undefined, 'img-fluid', 'Re-Use').style.maxHeight = '45px';
                });
                ks.is_item_clicked(function () {
                    ks.navigate_to('Home', '/');
                    return false;
                });
            });

            ks.h3('E-mail bevestiging', 'mb-3');

            ks.text(success ? 'Uw email is bevestigd, u wordt binnen enkele seconde omgeleid naar de login pagina.' : ('Uw email kon niet bevestigd worden, probeer het opnieuw. Neem contact met ons op als het probleem aanhoudt via ' + o_e_combine('info')), success ? '' : 'text-danger');

            if (success) {
                ks.set_timeout('redirect timer', 5000, function () {
                    ks.navigate_to('Login', Page.Login.path);
                });
            }
        });
    });
    el_card.style.maxWidth = '450px';
    el_card.style.marginTop = '8vh';
}


let run_product_filter = true;
// [SECTION] PAGE HOME
function page_shop(parameters: string) {
    let section = parse_page_section(parameters, [
        { name: 'home', pattern: '' },
        { name: 'category', pattern: 'c/{category}' },
        { name: 'product', pattern: 'p/{id:number}' },
        { name: 'product', pattern: 'p/{id:number}/{name}' },
    ]);

    let i_category = 0;
    if (section.name === 'category') {
        let c = section.values.category;
        for (let i = 1; i < product_category_names_plural.length; ++i) {
            if (case_insensitive_comp.compare(c, product_category_names_plural[i]) === 0) {
                i_category = i;
                break;
            }
        }
    }
    
    let search = (search_params.get('search') || '').toLowerCase();
    let state = ks.local_persist('state', {
        i_category: 0,
        products: <Product[]>[],
        search_fields: <string[]>[],
        filter: Object.create(null),
        filtered : <Product[]>[],
        prop_map: new Map<number, ProductProperty[]>(),

        product_id: 0,
    });

    let precondition = [];
    if (ks.is_new_scope()) {
        run_product_filter = true;

        precondition.push(xhr_get('/api/product').then(function (response: Product[]) {
            state.products.length = 0;
            // NOTE: take care when sorting product, search_fields must match the sorted values
            response.sort((a, b) => case_insensitive_comp.compare(a.name, b.name));
            response.sort((a, b) => a.category - b.category);
            response.sort((a, b) => a.stock && !b.stock ? -1 : (a.stock && b.stock ? 0 : 1));

            for (let i = 0; i < response.length; ++i) {
                let product: Product = response[i];
                product.properties.sort((a, b) => property_type_sort_val[a.type] - property_type_sort_val[b.type]);

                state.products.push(product);

                let str = product.name + ' ' + product.desc + ' ' + product.id;
                for (let k = 0; k < product.properties.length; ++k) {
                    let p = product.properties[k];
                    let opts = get_property_options(product.category, p.type);
                    if (opts) {
                        if (opts.length) { str += ' ' + opts[p.value]; }
                    } else {
                        str += ' ' + p.value + prop_type_units[p.type];
                    }
                }
                state.search_fields.push(str.toLowerCase());
            }

            run_product_filter = true;
            ks.refresh();
        }));
    };

    if (section.name === 'product' && (ks.is_new_scope() || state.product_id !== section.values.id)) {
        state.product_id = section.values.id;

        precondition.unshift(xhr_get('/api/product/' + section.values.id));
        Promise.all(precondition).then(function (responses) {
            let product = state.products.find(p => p.id === responses[0].id);
            if (product) {
                Object.assign(product, responses[0]);
                product.images.sort((a, b) => a.sortIndex - b.sortIndex);
            }
            ks.refresh();
        });
    } else if (precondition.length) {
        Promise.all(precondition).then(function () {
            ks.refresh();
        });
    }

    if (i_category !== state.i_category) {
        state.i_category = i_category;
        run_product_filter = true;

        for (let key in state.filter) {
            delete state.filter[key];
        }
    }

    if (run_product_filter) {
        run_product_filter = false;

        state.prop_map.clear();
        for (let i = 0; i < state.products.length; ++i) {
            let product = state.products[i];
            if (product.hidden || !i_category || i_category !== product.category) {
                continue;
            }

            for (let k = 0; k < product.properties.length; ++k) {
                let prop = product.properties[k];
                let arr = state.prop_map.get(prop.type);
                if (!arr) {
                    arr = [];
                    state.prop_map.set(prop.type, arr);
                }
                arr.push(prop);
            }
        }


        state.prop_map.forEach(function (properties, type) {
            properties.sort((a, b) => a.value - b.value);
            for (let i = properties.length - 1; i > 0; --i) {
                if (properties[i].value === properties[i - 1].value) {
                    properties.splice(i, 1);
                }
            }

            if (!(type in state.filter)) {
                state.filter[type] = Object.create(null);
            }
        });

        state.filtered.length = 0;
        for (let i = 0; i < state.products.length; ++i) {
            let product = state.products[i];
            if (product.hidden) {
                continue;
            }

            if ((!i_category || i_category === product.category) && (!search || state.search_fields[i].indexOf(search) >= 0) &&
                (!i_category ||product.properties.every(p => !Object.keys(state.filter[p.type]).length || p.value in state.filter[p.type]))) {
                state.filtered.push(product);
            }
        }
    }
    

    let compact = screen_sm || screen_md;
    let filter_expand = ks.local_persist('filter expand', { expand: false });
    if (section.name !== 'home') {
        ks.group('header', 'd-flex justify-content-between align-items-baseline', function () {
            let product: Product = null;
            if (section.name === 'product') {
                let id = section.values.id;
                product = state.products.find(p => p.id === id);
                if (!product) {
                    return;
                }
                i_category = product.category;
            }
            let crumbs = [i_category ? product_category_names_plural[i_category] : 'Alle artikelen'];
            if (product) { crumbs.push(product.name); }
            breadcrumbs(crumbs, function (i) {
                if (i === 0) {
                    ks.navigate_to(i_category ? product_category_names_plural[i_category] : 'Alle artikelen',
                        i_category ? '/c/' + product_category_names_plural[i_category].toLowerCase() : '/',
                    );
                }
            });

            if (compact && i_category && section.name !== 'product') {
                ks.group('filters', 'd-flex align-items-baseline', function () {
                    ks.set_next_item_class_name('text-nowrap ml-2');
                    ks.anchor('filters', '', function () {
                        ks.text('filters', 'd-inline');
                        ks.icon(filter_expand.expand ? 'far fa-chevron-down ml-1' : 'far fa-chevron-up ml-1');
                    });
                    ks.is_item_clicked(function () {
                        filter_expand.expand = !filter_expand.expand;
                        ks.refresh();
                        return false;
                    });
                });
            }
        });
    }

    if (section.name === 'product') {
        let id = section.values.id;
        let product = state.products.find(p => p.id === id);
        if (!product) {
            return;
        }
        ks.h3(product.name).style.fontWeight = '600';

        ks.group('row', 'row row-cols-1 row-cols-sm-2', function () {
            ks.group('images' + product.id, 'col', function () {
                let state_img = ks.local_persist('state', { img_id: product.imageId });
                if (ks.is_new_scope()) {
                    state_img.img_id = product.imageId;
                }
                ks.image('/api/product/image/' + state_img.img_id, undefined, undefined, 'img-fluid');

                if (product.images.length) {
                    ks.group('list', 'd-flex flex-wrap', function () {
                        ks.set_next_item_class_name(product.images.length ? 'mb-2 mr-2' : 'mb-2');
                        ks.anchor('' + product.imageId, '', function () {
                            let src = '/api/product/thumbnail/' + product.imageId;
                            if (state_img.img_id === product.imageId) { ks.set_next_item_class_name('border-primary'); }
                            img_cover(src, '100px', '100px', 'border rounded p-1');
                        });
                        ks.is_item_clicked(function () {
                            state_img.img_id = product.imageId;
                            ks.refresh();
                            return false;
                        });

                        for (let i = 0; i < product.images.length; ++i) {
                            let img = product.images[i];

                            ks.set_next_item_class_name(i + 1 < product.images.length ? 'mb-2 mr-2' : 'mb-2');
                            ks.anchor('' + img.id, '', function () {
                                let src = '/api/product/thumbnail/' + img.id;
                                if (state_img.img_id === img.id) { ks.set_next_item_class_name('border-primary'); }
                                img_cover(src, '100px', '100px', 'border rounded p-1');
                            });
                            ks.is_item_clicked(function () {
                                state_img.img_id = img.id;
                                ks.refresh();
                                return false;
                            });
                        }
                    });
                }
                
                ks.set_next_item_class_name('my-4');
                ks.separator();
            });

            ks.group('price', 'col', function () {
                product_option_selection('sets', 'mb-5', product, state.products);

                let stock = Math.max(product.stock, 0);

                ks.set_next_item_class_name('mb-3');
                price_label('price', product.price, true);

                ks.text('Niet alleen beter voor het milieu, ook voor uw portemonnee.', 'text-dark mb-3');

                ks.text(stock ? stock + ' op voorraad' : 'Niet op voorraad', stock ? 'border border-success px-2 text-center d-inline-block text-success rounded-sm mb-2' : 'border border-danger px-2 text-center d-inline-block text-danger rounded-sm mb-2').style.fontSize = '0.85rem';

                {
                    let cart_item = cart.find(i => i.productId === product.id)
                    ks.text(cart_item ? 'Aantal in uw winkelwagen: ' + cart_item.count : 'Nog niet toegevoegd aan uw winkelwagen', 'text-dark mb-2');
                }

                ks.group('add', 'd-flex flex-row mb-2', function () {
                    let cart_item = cart.find(item => item.productId === product.id);
                    let available = cart_item ? Math.max(stock - cart_item.count, 0) : stock;
                    let count = ks.local_persist('state count', { count: Math.min(available, 1) });
                    if (ks.is_new_scope()) {
                        count.count = Math.min(available, 1);
                    };

                    ks.set_next_item_class_name('form-control-lg mr-2');
                    let input = ks.input_number('count', count.count, '', function (val) {
                        count.count = val;
                    }, 1, Math.max(available, 1), 1);
                    input.disabled = available === 0;
                    input.style.width = '90px';

                    let btn_state = ks.local_persist('btn', { clicked: false });
                    if (ks.is_new_scope()) {
                        btn_state.clicked = false;
                    };
                    ks.set_next_item_class_name('d-flex flex-row align-items-baseline btn-lg text-nowrap');
                    let btn = ks.button_container('Add to cart', function () {
                        ks.icon(btn_state.clicked ? 'far fa-check mr-2' : 'far fa-shopping-cart mr-2').style.width = '22.5px';
                        ks.text('In winkelwagen');
                    });
                    btn.style.background = '#009a8a';
                    btn.disabled = available === 0;
                    ks.is_item_clicked(function () {
                        if (!btn_state.clicked) {
                            btn_state.clicked = true;

                            load_cart();
                            let amount = Math.min(count.count, available);
                            count.count = Math.min(count.count, available - count.count);
                            let cart_item = cart.find(i => i.productId === product.id);
                            if (cart_item) {
                                cart_item.count += amount;
                            } else {
                                cart.push({ productId: product.id, count: amount });
                            }
                            save_cart();

                            ks.refresh();
                        }
                    });
                    if (btn_state.clicked) {
                        ks.set_timeout('btn_timeout', 1500, function () {
                            btn_state.clicked = false;
                            ks.refresh();
                        });
                    }
                });

                ks.group('benefits', 'text-success mb-3', function () {
                    ks.group('circular', '', function () {
                        ks.icon('fal fa-check');
                        ks.text(' Circulair product', 'd-inline');
                    });

                    ks.group('co2', '', function () {
                        ks.icon('fal fa-check');
                        ks.text(' CO₂ equivalent ', 'd-inline');
                        ks.text(Math.round(product.weight * product.co2PerKg * 10) / 10 + ' kg', 'd-inline font-weight-bold');
                    });

                    if (product.category === ProductCategory.Toilet) {
                        ks.group('flush', '', function () {
                            ks.icon('fal fa-check');
                            ks.text(' Inclusief spoelverdeler', 'd-inline');
                        });
                    }
                });

                ks.set_next_item_class_name('my-4');
                ks.separator();
            });

            ks.group('specs', 'col', function () {
                if (product.desc) {
                    ks.h5('Productbeschrijving', 'font-weight-bold');
                    ks.text(product.desc, 'text-dark').style.whiteSpace = 'pre';

                    ks.set_next_item_class_name('my-4');
                    ks.separator();
                }

                ks.h5('Productspecificaties', 'font-weight-bold');

                ks.set_next_item_class_name('table-sm table-striped table-borderless');
                ks.table('table', function () {
                    ks.table_body(function () {
                        for (let i = 0; i < product.properties.length; ++i) {
                            let prop = product.properties[i];
                            let name = property_type_names[prop.type];
                            let opts = get_property_options(product.category, prop.type);
                            if (!opts && !prop.value) {
                                continue;
                            }

                            ks.table_row(function () {
                                ks.table_cell(name);
                                ks.table_cell(opts ? opts[prop.value] : prop.value + prop_type_units[prop.type]);
                            });
                        }

                        ks.table_row(function () {
                            ks.table_cell('Gewicht');
                            ks.table_cell(product.weight + ' kg');
                        });

                        ks.table_row(function () {
                            ks.table_cell('Artikelnummer');
                            ks.table_cell('' + product.id);
                        });
                    });
                });

                ks.set_next_item_class_name('my-4 d-sm-none d-block');
                ks.separator();
            });
        });
    }

    if (section.name === 'home' || section.name === 'category') {
        ks.row('panels' + i_category, function () {
            ks.set_next_item_class_name('text-dark');
            let el_filters = ks.group('filters', 'col-lg-2 col-md-3', function () {
                if (!compact) {
                    ks.group('categories', 'mb-4', function () {
                        ks.text('Categorieën', 'font-weight-bold');

                        ks.set_next_item_class_name('my-2');
                        ks.separator();

                        for (let i = 1; i < product_category_names_plural.length; ++i) {
                            let url = '/c/' + product_category_names_plural[i].toLowerCase();
                            ks.set_next_item_class_name('d-block text-dark');
                            let a = ks.anchor(product_category_names_plural[i], url);
                            if (i_category === i) {
                                a.style.textDecoration = 'underline';
                            }
                            ks.is_item_clicked(function () {
                                ks.navigate_to(product_category_names_plural[i], url);
                                return false;
                            });
                        }
                    });
                }

                if (i_category) {
                    ks.push_id('props' + i_category);

                    if (!compact || filter_expand.expand) {
                        state.prop_map.forEach(function (properties, type) {
                            // TODO: hide if only one property shows up, don't want to duplicate logic below so need to
                            // retroactively fill in this header and early out in the logic below
                            ks.text(property_type_names[type], 'font-weight-bold');
                            ks.set_next_item_class_name('my-2');
                            ks.separator();

                            ks.push_id(type);

                            ks.group('properties', 'mb-4', function () {
                                let options = get_property_options(i_category, type);

                                for (let i = 0; i < properties.length; ++i) {
                                    let p = properties[i];
                                    if (!options && !p.value) { continue; }

                                    let label = options ? options[p.value] : p.value + ' cm';
                                    ks.checkbox(label, state.filter[type][p.value], function (checked) {
                                        if (checked) {
                                            state.filter[type][p.value] = true;
                                        } else {
                                            delete state.filter[type][p.value];
                                        }
                                        run_product_filter = true;
                                        ks.refresh();
                                    });
                                }
                            });

                            ks.pop_id();
                        });
                    }

                    ks.pop_id();
                }
            });
            el_filters.style.lineHeight = '1.6';
            el_filters.style.fontSize = '0.9rem'

            ks.group('items', 'col-lg-10 col-md-9 col-sm-12', function () {
                if (search) {
                    // Note: getting value from search params so that capitals matches
                    ks.h3("'" + search_params.get('search') + "' in " +
                        (product_category_names_plural[i_category] || 'Alle artikelen'), 'mb-3 text-dark');
                } else {
                    ks.h3(product_category_names_plural[i_category] || 'Alle artikelen', 'mb-3 text-dark');
                }

                if (!search && !i_category) {
                    let banner = ks.group('banner', 'banner d-flex flex-column justify-content-center rounded-lg border text-center px-4 py-2 mb-3', function () {
                        let title = ks.h1('Groots in kwaliteit, klein in voetafdruk.', 'font-weight-bold mx-3');
                        title.style.fontSize = screen_compact || screen_lg ? '1.75rem' : '2.25rem';
                        title.style.textShadow = '0 0 11px rgb(47, 106, 86)';

                        let subtitle = ks.h4('Ontdek ons circulair aanbod, hoogwaardig en zo goed als nieuw.', 'font-weight-bold');
                        subtitle.style.textShadow = '0 0 8px rgb(47, 106, 86)';
                        subtitle.style.fontSize = screen_compact || screen_lg ? '1rem' : '1.25rem';
                    });
                    banner.style.minHeight = '180px';
                }

                ks.group('results', 'd-flex', function () {
                    if (state.filtered.length) {
                        ks.text(state.filtered.length + (state.filtered.length > 1 ? ' resultaten' : ' resultaat'), 'mb-4 text-dark');
                    } else {
                        ks.text('Geen artikelen gevonden', 'mb-4 text-dark');
                    }
                });

                for (let i = 0; i < state.filtered.length; ++i) {
                    ks.set_next_item_class_name('mb-5');
                    shop_item(state.filtered[i]);
                }
            });
        });
    }
}

function price_label(id: string, price: number, large: boolean) {
    let el = ks.group(id, 'd-flex text-danger font-weight-bold', function () {
        let whole = Math.floor(price / 100);
        let decimals = price % 100;
        let font_size = large ? '2.1rem' : '1.7rem';
        let font_size_decimals = large ? '1.25rem' : '1rem';

        ks.text(whole + ',', 'd-inline').style.fontSize = font_size;
        let el_deci = ks.text(decimals ? '' + decimals : '-', 'd-inline');
        el_deci.style.marginLeft = decimals ? (large ? '-0.15rem' : '-0.12rem') : (large ? '-0.4rem' : '-0.32rem');
        el_deci.style.fontSize = decimals ? font_size_decimals : font_size;
        el_deci.style.lineHeight = decimals ? '1.275' : '0.9';
    });
    el.style.lineHeight = '1';
    return el;
}

function img_cover(src: string, width: string, height: string, class_name: string) {
    let img = ks.text('', class_name);
    img.style.backgroundImage = 'url("' + src + '")';
    img.style.backgroundRepeat = 'no-repeat';
    img.style.backgroundSize = 'cover';
    img.style.backgroundPosition = 'center';
    img.style.flexBasis = screen_sm ? '150px' : '120px';
    img.style.width = width;
    img.style.height = height;
    return img;
}

function item_prop_desc(p: Product): string {
    let desc = '';
    for (let i = 0; i < p.properties.length; ++i) {
        let prop = p.properties[i];

        let name = property_type_names[prop.type];
        let opts = get_property_options(p.category, prop.type);

        if (desc && (opts || prop.value)) {
            desc += ' • ';
        }
        if ((opts || prop.value) && prop_type_labeled[prop.type]) {
            desc += name + ': ';
        }

        if (opts) {
            desc += opts[prop.value];
        } else if (prop.value) {
            desc += prop.value + prop_type_units[prop.type];
        }
    }
    return desc;
};

function shop_item(p: Product) {
    ks.group('product' + p.id, screen_sm ? 'd-flex flex-column' : 'd-flex flex-row', function () {
        let url = make_url_product(p.id, p.name);
        ks.set_next_item_class_name(screen_sm ? 'd-flex flex-column text-body text-decoration-none' : 'd-flex flex-row flex-grow-1 text-body text-decoration-none');
        ks.anchor('product', url, function () {
            let img_bg = ks.group('img', 'flex-shrink-0 flex-grow-0 mr-0 mr-sm-3 mb-1 mb-sm-0', ks.no_op);
            img_bg.style.backgroundImage = 'url("/api/product/thumbnail/' + p.imageId + '")';
            img_bg.style.backgroundRepeat = 'no-repeat';
            img_bg.style.backgroundSize = 'contain';
            img_bg.style.backgroundPosition = 'center';
            img_bg.style.flexBasis = screen_sm ? '150px' : '120px';
            img_bg.style.width = screen_sm ? '150px' : '120px';
            img_bg.style.height = screen_sm ? '150px' : '120px';

            ks.group('desc', 'd-flex flex-column flex-grow-1 mr-0 mr-sm-3', function () {
                ks.h5(p.name, 'product-title mb-1');

                ks.text(item_prop_desc(p), 'text-muted mb-1').style.fontSize = '0.8rem';

                if (p.desc) {
                    let desc = ks.text(p.desc, 'mb-1 text-dark');
                    desc.style.whiteSpace = 'pre';
                }

                ks.group('co2', 'text-success', function () {
                    ks.text('CO₂ equivalent ', 'd-inline');
                    ks.text(Math.round(p.weight * p.co2PerKg * 10) / 10 + ' kg', 'd-inline font-weight-bold');
                });
            });
        });
        ks.is_item_clicked(function () {
            ks.navigate_to(p.name, url);
            window.scrollTo(0, 0);
            return false;
        });

        ks.group('price', 'd-flex flex-column ml-0 ml-sm-3 mt-3 mt-sm-0', function () {
            let stock = Math.max(p.stock, 0);

            ks.set_next_item_class_name('mb-3 flex-grow-1');
            price_label('price', p.price, false);

            ks.group('add', 'd-flex flex-row mb-1', function () {
                let cart_item = cart.find(item => item.productId === p.id);
                let available = cart_item ? Math.max(stock - cart_item.count, 0) : stock;
                let count = ks.local_persist('state count', { count: Math.min(available, 1) });
                if (ks.is_new_scope()) {
                    count.count = Math.min(available, 1);
                };

                ks.set_next_item_class_name('mr-2');
                let input = ks.input_number('count', count.count, '', function (val) {
                    count.count = val;
                }, 1, Math.max(available, 1), 1);
                input.disabled = available === 0;
                input.style.width = '90px';

                ks.set_next_item_class_name('text-nowrap');
                let btn_state = ks.local_persist('btn', { clicked: false });
                if (ks.is_new_scope()) {
                    btn_state.clicked = false;
                };
                let btn = ks.button_container('Add to cart', function () {
                    ks.icon(btn_state.clicked ? 'far fa-check mr-2' : 'far fa-plus mr-2').style.width = '16px';
                    ks.icon('far fa-shopping-cart');
                });
                btn.style.background = '#009a8a';
                btn.disabled = available === 0;
                ks.is_item_clicked(function () {
                    if (!btn_state.clicked) {
                        btn_state.clicked = true;

                        load_cart();
                        let amount = Math.min(count.count, available);
                        count.count = Math.min(count.count, available - count.count);
                        let cart_item = cart.find(i => i.productId === p.id);
                        if (cart_item) {
                            cart_item.count += amount;
                        } else {
                            cart.push({ productId: p.id, count: amount });
                        }
                        save_cart();

                        ks.refresh();
                    }
                });
                if (btn_state.clicked) {
                    ks.set_timeout('btn_timeout', 1500, function () {
                        btn_state.clicked = false;
                        ks.refresh();
                    });
                }
            });

            ks.text(stock ? stock + ' op voorraad' : 'Niet op voorraad', stock ? 'text-muted' : 'text-danger');
        });
    });
}

function product_option_selection(id: string, class_name: string, product: Product, products: Product[]) {
    const class_option_btns = [
        'mb-2 btn btn-outline-secondary',
        'mb-2 btn btn-outline-primary',
        'mb-2 btn btn-outline-secondary mr-2 ',
        'mb-2 btn btn-outline-primary mr-2 ',
    ];

    return ks.group(id, class_name, function () {
        let state = ks.local_persist('state', {
            pid: 0,

            map_values: new Map<number, { product: Product, value: number }[]>(),
        });

        if (product.id !== state.pid) {
            let map_options = new Map<number, Product[]>();
            
            for (let i_prod = 0; i_prod < products.length; ++i_prod) {
                let other = products[i_prod];
                if (product.category !== other.category) {
                    continue;
                }

                let i_prop = 0;
                let num_diffs = 0;
                if (product.properties.length === other.properties.length) {
                    // Assumes properties are ordered
                    for (let i = 0; i < product.properties.length; ++i) {
                        let pp = product.properties[i];
                        let op = other.properties[i];

                        if (pp.type !== op.type) {
                            num_diffs = 400;
                            break;
                        }

                        if (pp.value !== op.value) {
                            i_prop = i;
                            num_diffs += 1;
                            if (num_diffs > 1) {
                                break;
                            }
                        }
                    }
                }

                if (num_diffs === 1) {
                    let opts = map_options.get(i_prop);
                    if (!opts) {
                        opts = [];
                        map_options.set(i_prop, opts);
                    }
                    opts.push(other);
                }
            }

            state.map_values.clear();
            for (const [i_prop, others] of map_options) {
                let prop = product.properties[i_prop];
                let values: { product: Product, value: number }[] = [];

                let opts = get_property_options(product.category, prop.type);
                if (!opts && !prop.value) {
                    continue;
                }

                values.push({ product: product, value: prop.value });
                for (let i = 0; i < others.length; ++i) {
                    let other = others[i];
                    values.push({ product: other, value: other.properties[i_prop].value });
                }

                values.sort((a, b) => a.value - b.value);
                state.map_values.set(prop.type, values);
            }
        }

        for (let i_prop = 0; i_prop < product.properties.length; ++i_prop) {
            let prop = product.properties[i_prop];
            let values = state.map_values.get(prop.type);
            if (!values) {
                continue;
            }

            let opts = get_property_options(product.category, prop.type);

            ks.push_id(i_prop);
            ks.text('Kies ' + property_type_names[prop.type].toLowerCase(), 'font-weight-bold mb-2');

            for (let i = 0; i < values.length; ++i) {
                let v = values[i];

                ks.push_id(i);
                let label = opts ? opts[v.value] : '' + values[i].value + prop_type_units[prop.type];
                let highlight = prop.value === v.value;
                let url = make_url_product(v.product.id, v.product.name);

                ks.set_next_item_class_name(class_option_btns[(i + 1 < values.length ? 1 : 0) * 2 + (highlight ? 1 : 0)]);
                let anchor = ks.anchor(label, url);
                anchor.style.pointerEvents = highlight ? 'none' : ''
                ks.is_item_clicked(function () {
                    anchor.blur();
                    ks.navigate_to(v.product.name, url);
                    return false;
                });
                ks.pop_id();
            }
            ks.pop_id();
        }
    });
}


// [SECTION] PAGE CART
function page_cart() {
    let products = ks.local_persist('products', <Product[]>[]);
    let product_map = ks.local_persist('product map', new Map<number, Product>());
    if (ks.is_new_scope()) {
        xhr_get('/api/product').then(function (response: any[]) {
            products.length = 0;
            for (let i = 0; i < response.length; ++i) {
                products.push(response[i]);
                product_map.set(response[i].id, response[i]);
            }
            ks.refresh();
        });
    };
    if (products.length === 0) {
        return;
    }

    load_cart();
    if (cart.length) {
        ks.h3('Winkelwagen', 'mb-4');

        ks.set_next_item_class_name('mx-n2');
        ks.row('cart', function () {
            ks.set_next_item_class_name('px-2');
            ks.group('cart_items', 'col-lg-8', function () {
                for (let i = 0; i < cart.length; ++i) {
                    cart_item('' + i, cart[i], product_map.get(cart[i].productId));
                }
            });

            ks.set_next_item_class_name('px-2');
            ks.group('overview', 'col-lg-4 mb-4', function () {
                ks.group('overview', 'border rounded px-3 py-3', function () {
                    ks.h5('Overzicht', 'font-weight-bold text-dark');

                    let sum_co2 = 0;
                    let sum_price = 0;
                    for (let i = 0; i < cart.length; ++i) {
                        let p = product_map.get(cart[i].productId);
                        sum_co2 += p.co2PerKg * p.weight * cart[i].count;
                        sum_price += p.price * cart[i].count;
                    }

                    ks.group('price', 'd-flex flex-row align-items-baseline', function () {
                        ks.text('Totaal artikelen');
                        ks.text('(' + cart.length + ')', 'text-muted flex-grow-1 ml-1').style.fontSize = '0.9rem';
                        ks.text(euro_fmt.format(sum_price / 100), 'font-weight-bold text-dark');
                    });

                    ks.group('co2', 'd-flex flex-row', function () {
                        ks.text('CO₂ equivalent', 'flex-grow-1');
                        ks.text(total_co2_formatted(sum_co2) + ' kg', 'font-weight-bold text-success');
                    });

                    ks.separator();

                    ks.text('Prijzen zijn ex. btw', 'text-center text-muted');

                    ks.button('Verder naar bestellen', function () {
                        ks.navigate_to('Bestellen', '/bestellen');
                    }, 'primary btn-lg btn-block mt-4');
                });
            });
        });
    } else {
        ks.icon('fal fa-box-open d-block text-center text-primary mt-5').style.fontSize = '3rem';
        ks.h2('Uw winkelwagen is nog leeg.', 'text-primary text-center mb-4');
    }

    ks.group('center', cart.length ? '' : 'd-flex justify-content-center', function () {
        ks.set_next_item_class_name('text-nowrap');
        ks.button_container('Verder winkelen', function () {
            ks.icon('fa fa-chevron-left mr-2');
            ks.text('Verder winkelen', 'd-inline');
        }, 'outline-primary');
        ks.is_item_clicked(function () {
            ks.navigate_to('Home', '/');
        });
    });
}

function cart_item(id: string, item: { productId: number, count: number }, p: Product) {
    ks.group(id, (screen_sm ? 'flex-column' : 'flex-row') + ' d-flex border rounded px-4 py-3 mb-3', function () {
        let url = make_url_product(p.id, p.name);
        
        ks.anchor('img', url, function () {
            let size = screen_sm ? '150px' : '100px';
            let img = img_cover('/api/product/thumbnail/' + p.imageId, size, size, 'flex-shrink-0 flex-grow-0 mr-3')
            img.style.backgroundSize = 'contain';
            img.style.flexBasis = size;
        });
        ks.is_item_clicked(function () {
            ks.navigate_to(p.name, url);
            return false;
        });

        let stock = Math.max(p.stock, 1);
        ks.group('info', 'd-flex flex-column flex-grow-1', function () {
            ks.group('desc', 'd-flex justify-content-between', function () {
                ks.set_next_item_class_name('font-weight-bold text-dark mr-2');
                ks.anchor(p.name, url);
                ks.is_item_clicked(function () {
                    ks.navigate_to(p.name, url);
                    return false;
                });
                ks.text(euro_fmt.format(p.price / 100), 'font-weight-bold text-dark text-right text-nowrap');
            });

            ks.group('price', 'd-flex justify-content-between', function () {
                ks.group('count', 'd-flex align-items-center mt-2', function () {
                    ks.set_next_item_class_name('mr-4');
                    ks.input_number('count', item.count, '', function (val) {
                        load_cart();
                        for (let i = 0; i < cart.length; ++i) {
                            if (cart[i].productId === p.id) {
                                cart[i].count = Math.min(val, stock);
                                save_cart();
                                break;
                            }
                        }

                        ks.refresh();
                    }, 1, stock, 1).style.maxWidth = '90px';

                    let anchor = ks.anchor('remove', '', function () {
                        ks.icon('fal fa-trash-alt mr-2');
                    });
                    anchor.style.lineHeight = '1'
                    anchor.style.fontSize = '1.25rem';
                    ks.is_item_clicked(function () {
                        load_cart();
                        for (let i = 0; i < cart.length; ++i) {
                            if (cart[i].productId === p.id) {
                                cart.splice(i, 1);
                                save_cart();
                                break;
                            }
                        }

                        ks.refresh();
                        return false;
                    });
                });

                ks.group('co2', 'text-success text-right', function () {
                    ks.text('CO₂ eq. ', 'd-inline');
                    ks.text(total_co2_formatted(p.weight * p.co2PerKg) + ' kg', 'd-inline font-weight-bold');
                });
            });
        });
    });
}


// [SECTION] PAGE ORDER
function page_order() {
    let state = ks.local_persist('state', {
        products: <Product[]>[],
        product_map: new Map<number, Product>(),
        order_completed: '', // set to email of recipient

        discount: 0,
        emailInvoice: '',
        resolved: false,
    });
    if (ks.is_new_scope()) {
        state.emailInvoice = '';
        state.resolved = false;

        state.order_completed = '';

        let waitlist: Promise<unknown>[] = [];

        waitlist.push(xhr_get('/api/organization/mine').then(function (response: any) {
            state.emailInvoice = response.emailInvoice || '';
            state.discount = response.discount;
        }));

        waitlist.push(xhr_get('/api/product').then(function (response: any[]) {
            state.products.length = 0;
            state.product_map.clear();
            for (let i = 0; i < response.length; ++i) {
                state.products.push(response[i]);
                state.product_map.set(response[i].id, response[i]);
            }
        }));

        Promise.all(waitlist).then(function () {
            state.resolved = true;
            ks.refresh();
        });
    };

    if (!state.resolved) {
        return;
    }

    if (state.order_completed) {
        ks.icon('fal fa-box-check d-block text-center text-primary mt-5 mb-3').style.fontSize = '3rem';
        ks.h2('Bedankt voor uw bestelling.', 'text-primary text-center');
        ks.h5('Er is een bevestiging verstuurd naar ' + state.order_completed, 'text-center mb-5');

        ks.group('center', 'd-flex justify-content-center', function () {
            ks.set_next_item_class_name('text-nowrap');
            ks.button_container('Verder winkelen', function () {
                ks.icon('fa fa-chevron-left mr-2');
                ks.text('Verder winkelen', 'd-inline');
            }, 'outline-primary');
            ks.is_item_clicked(function () {
                ks.navigate_to('Home', '/');
            });
        });
        return;
    }

    load_cart();
    if (cart.length) {
        let fetching = ks.local_persist('zipcode_fetch', { zipcode: false, submit: false });

        let pickup = false;
        let form: HTMLFormElement;
        ks.set_next_item_class_name('mx-n2');
        ks.row('order', function () {
            ks.set_next_item_class_name('px-2');
            ks.group('form', 'col-lg-8', function () {
                form = ks.form('order', '', false, function () {
                    let order = ks.local_persist('order', {
                        firstName: '',
                        middleName: '',
                        lastName: '',
                        email: state.emailInvoice,
                        remarks: '',
                        poNumber: '',
                        city: '',
                        street: '',
                        houseNr: 0,
                        houseAffix: '',
                        zipcode: '',
                        dateScheduled: new Date(),
                        pickup: false,
                        timePickup: '',
                        modelFree: false,
                        orderItems: [],
                    });

                    pickup = order.pickup;

                    ks.set_next_item_class_name('mb-3');
                    ks.row('name', function () {
                        ks.group('first', 'col-12 col-xl-5', function () {
                            ks.text('Voornaam', 'mb-1');

                            ks.set_next_input_validation(order.firstName.length > 0, '', '');
                            ks.input_text('first', order.firstName, '', function (val) {
                                order.firstName = val;
                            });
                        });

                        ks.group('middle', 'col-12 col-xl-2', function () {
                            ks.text('Tussenvoegsel', 'mb-1 mt-3 mt-xl-0');

                            ks.input_text('middle', order.middleName, '', function (val) {
                                order.middleName = val;
                            });
                        });

                        ks.group('last', 'col-12 col-xl-5', function () {
                            ks.text('Achternaam', 'mb-1 mt-3 mt-xl-0');

                            ks.set_next_input_validation(order.lastName.length > 0, '', '');
                            ks.input_text('last', order.lastName, '', function (val) {
                                order.lastName = val;
                            });
                        });
                    });

                    if (!user.id) {
                        ks.set_next_item_class_name('d-flex align-items-center');
                        ks.alert_box('email info', 'info', true, function () {
                            ks.icon('fal fa-info mr-3').style.fontSize = '2rem';
                            ks.text('Als uw email bekend is bij ons dan gaan we direct aan de slag met uw bestelling. Zo niet, dan nemen wij zo spoedig mogelijk contact met u op.');
                        });
                    }

                    ks.text(user.id ? 'Email factuur' : 'Email', 'mb-1');
                    let valid_email = order.email.includes('@') && order.email.includes('.') && order.email.length < 256;
                    ks.set_next_input_validation(valid_email, '', 'Voer een geldig email adres in');
                    ks.input_text('email', order.email, '', function (val) {
                        order.email = val;
                    }).type = 'email';

                    ks.text('PO nummer', 'mb-1');
                    ks.set_next_input_validation(order.poNumber.length < 256, '', 'Dit veld mag maximaal 255 tekens bevatten');
                    ks.input_text('ponr', order.poNumber, 'Voor uw eigen administratie', function (val) {
                        order.poNumber = val;
                    });

                    ks.text('Opmerking', 'mb-1');
                    ks.set_next_input_validation(order.remarks.length < 4096, '', 'Dit veld mag maximaal 4096 tekens bevatten');
                    ks.input_text_area('remarks', order.remarks, 
                    'Opmerkingen over uw bestelling kunt u hier plaatsen', function (val) {
                        order.remarks = val;
                    });

                    let info_box: HTMLElement;
                    ks.group('models', 'd-flex align-items-baseline mb-4', function () {
                        ks.set_next_item_class_name('mr-2');
                        ks.checkbox('Modellen met dezelfde afmetingen zijn uitwisselbaar', order.modelFree, function (checked) {
                            order.modelFree = checked;
                        });
                        ks.anchor('info icon', '', function () {
                            ks.icon('far fa-info-circle');
                        });
                        ks.is_item_clicked(function () {
                            info_box.style.display = '';
                            return false;
                        });
                    });

                    info_box = ks.group('info', 'alert alert-info', function () {
                        ks.set_next_item_class_name('close');
                        let btn = ks.button_container('##close', function () {
                            ks.text('×').setAttribute('aria-hidden', 'true');
                        }, '');
                        btn.type = 'button';
                        btn.setAttribute('aria-label', 'Close');
                        ks.is_item_clicked(function () {
                            this.style.display = 'none';
                        });

                        ks.text('Ten behoeve van duurzaamheid is het belangrijk dat vraag en aanbod in balans is. Als de afmetingen en eigenschappen hetzelfde zijn, kunnen wij andere beschikbare modellen leveren.');
                        ks.text('Dit gebeurd altijd in overleg tenzij anders is afgesproken.');
                    });
                    if (ks.is_new_scope()) {
                        info_box.style.display = 'none';
                    };


                    function streetname_proc(zipcode: string, housenr: number) {
                        if (!is_valid_zipcode(zipcode)) {
                            return;
                        }
                        let requested = ks.local_persist('zip requested', { zipcode: '', housenr: 0 });
                        if (zipcode && housenr && (zipcode !== requested.zipcode || housenr !== requested.housenr)) {
                            requested.zipcode = zipcode;
                            requested.housenr = housenr;
                            
                            if (!fetching.zipcode) {
                                xhr_get('/api/zipcode?zipcode=' + zipcode + '&housenr=' + housenr).then(function (response: any) {
                                    order.street = response.street;
                                    order.city = response.city;
                                }).catch(function (reason: XHR_Reason) {
                                    if (reason.status === 404) {
                                        // TODO: notify user, maybe accept based on user input?
                                    }
                                }).finally(function () {
                                    fetching.zipcode = false;
                                    ks.refresh();
                                });
                            }
                        }
                    }

                    function register_zipcode_listeners(input: HTMLInputElement) {
                        if (ks.is_new_scope()) {
                            input.addEventListener('keydown', function (ev) {
                                if (ev.key === 'Enter') {
                                    streetname_proc(order.zipcode, order.houseNr);
                                }
                            });
                            input.addEventListener('focusout', function (ev) {
                                streetname_proc(order.zipcode, order.houseNr);
                            });
                        };
                    }

                    ks.set_next_item_class_name('mb-2');
                    ks.checkbox('Afhalen', order.pickup, function (checked) {
                        order.pickup = checked;
                        ks.refresh();
                    });

                    if (order.pickup) {
                        ks.h5('Afhaalgegevens');
                        ks.group('pickup', 'card mb-3', function () {
                            if (ks.is_new_scope()) {
                                order.dateScheduled = new Date();
                            }

                            ks.group('body', 'card-body', function () {
                                ks.h5('Kabelstraat 12', 'mb-0');
                                ks.text('1322AD Almere', 'mb-1');
                                ks.anchor('Route', 'https://maps.app.goo.gl/9cxMUHcFeGXChUSi6').target = '_blank';
                            });
                        });

                        ks.text('Gewenste afhaaldatum', 'mb-1');
                        ks.row('pickup date', function () {
                            let el_date = ks.input_date('date pickup', date_input_format(order.dateScheduled), '', function (val) {
                                let date = new Date(val);
                                while (date.getDay() === 0 || date.getDay() === 6) {
                                    date.setDate(date.getDate() + 1);
                                }
                                order.dateScheduled = date;
                                ks.refresh(this);
                            });
                            el_date.min = date_input_format(new Date());

                            ks.input_text('time pickup', order.timePickup, 'Tijd', function (val) {
                                order.timePickup = val.length <= 63 ? val : val.substring(0, 63);
                                ks.refresh(this);
                            });
                        });
                    } else {
                        ks.h5('Levergegevens');

                        ks.set_next_item_class_name('mb-3');
                        ks.row('adres', function () {
                            if (ks.is_new_scope()) {
                                let date = new Date();
                                // If ordered on the weekends, go to first workday
                                while (date.getDay() === 0 || date.getDay() === 6) {
                                    date.setDate(date.getDate() + 1);
                                }

                                date.setDate(date.getDate() + 5);

                                while (date.getDay() === 0 || date.getDay() === 6) {
                                    date.setDate(date.getDate() + 1);
                                }
                                order.dateScheduled = date;
                            }

                            ks.group('zip', 'col-12 col-sm-6', function () {
                                ks.text('Postcode', 'mb-1');

                                ks.set_next_input_validation(is_valid_zipcode(order.zipcode), '',
                                    'Voer een postcode van 4 cijfers en 2 letters in zonder spatie');
                                let input = ks.input_text('zip', order.zipcode, 'Bijvoorbeeld: 1234AA', function (val) {
                                    if (val.length === 7 && val[4] === ' ') {
                                        val = val.substring(0, 4) + val.substring(5, 7);
                                    }
                                    order.zipcode = val.toUpperCase();
                                    ks.refresh(this);
                                });
                                register_zipcode_listeners(input);
                            });

                            ks.group('housenr', 'col-12 col-sm-6 mt-3 mt-sm-0', function () {
                                ks.text('Huisnr. en toevoeging', 'mb-1');

                                ks.set_next_input_validation(!!order.houseNr, '', 'Voer een huisnummer in dat een cijfer bevat');
                                let input = ks.input_text('housenr', order.houseAffix, 'Bijvoorbeeld 12A', function (val) {
                                    let i_nr_begin = -1;
                                    let i_nr_end = 0;
                                    for (let i = 0; i < val.length; ++i, ++i_nr_end) {
                                        if (val[i] >= '0' && '9') {
                                            if (i_nr_begin < 0) {
                                                i_nr_begin = i;
                                            }
                                        } else if (i_nr_begin >= 0) {
                                            break;
                                        }
                                    }
                                    if (i_nr_begin < 0) {
                                        order.houseNr = 0;
                                    }
                                    order.houseNr = i_nr_begin < 0 ? 0 : parseInt(val.substring(i_nr_begin, i_nr_end), 10);
                                    order.houseAffix = val;
                                });
                                register_zipcode_listeners(input);
                            });
                        });

                        ks.text('Straatnaam', 'mb-1');
                        ks.input_text('street', order.street, '', function (val) {
                        }).disabled = true;

                        ks.text('Plaats', 'mb-1');
                        ks.input_text('city', order.city, '', function (val) {
                        }).disabled = true;

                        ks.text('Gewenste leverdatum', 'mb-1');
                        let el_date = ks.input_date('date deliver', date_input_format(order.dateScheduled), '', function (val) {
                            let date = new Date(val);
                            while (date.getDay() === 0 || date.getDay() === 6) {
                                date.setDate(date.getDate() + 1);
                            }
                            order.dateScheduled = date;
                            ks.refresh(this);
                        });
                        el_date.min = date_input_format(new Date());
                    }


                    if (ks.current_form_submitted()) {
                        if (!fetching.zipcode && !form.getElementsByClassName('is-invalid').length) {
                            fetching.submit = true;
                            order.orderItems = cart;
                            xhr_send('POST', '/api/order?sendEmail=true', order).then(function (response) {
                                state.order_completed = order.email;
                                cart.length = 0;
                                save_cart();
                            }).finally(function () {
                                fetching.submit = false;
                                ks.refresh();
                            });

                            ks.unsubmit_current_form();
                        }
                    }
                });
            });

            ks.set_next_item_class_name('px-2');
            ks.group('overview', 'col-lg-4', function () {
                ks.group('overview', 'border rounded px-3 py-3 mb-3', function () {
                    ks.h5('Overzicht', 'font-weight-bold text-dark');

                    let sum_co2 = 0;
                    let sum_price = 0;
                    for (let i = 0; i < cart.length; ++i) {
                        let p = state.product_map.get(cart[i].productId);
                        sum_co2 += p.co2PerKg * p.weight * cart[i].count;
                        sum_price += p.price * cart[i].count;
                    }

                    let overview = ks.local_persist('collapse', {
                        collapse: true,
                    });

                    ks.group('price', 'd-flex flex-row align-items-baseline', function () {
                        ks.group('title', 'd-flex flex-row align-items-baseline flex-grow-1 mr-1 cursor-pointer', function () {
                            ks.text('Artikelen');
                            ks.text('(' + cart.length + ')', 'text-muted mx-1').style.fontSize = '0.9rem';
                            ks.icon(overview.collapse ? 'fal fa-chevron-up' : 'fal fa-chevron-down').style.fontSize = '0.9rem';
                        });
                        ks.is_item_clicked(function () {
                            overview.collapse = !overview.collapse;
                            ks.refresh();
                        });
                        ks.text(euro_fmt.format(sum_price / 100), 'font-weight-bold text-dark');
                    });

                    ks.unordered_list('items', overview.collapse ? 'collapse mt-1' : 'collapse show mt-1', function () {
                        for (let i = 0; i < cart.length; ++i) {
                            let p = state.product_map.get(cart[i].productId);
                            ks.list_item('' + i, '', function () {
                                ks.group('flex', 'd-flex align-items-baseline', function () {
                                    let count = cart[i].count;
                                    ks.text(p.name, count > 1 ? '' : 'flex-grow-1').style.fontSize = '0.95rem';
                                    if (count > 1) {
                                        ks.text('x' + count, 'flex-grow-1 text-muted mx-1').style.fontSize = '0.9rem';
                                    }
                                    ks.text(euro_fmt.format(count * p.price / 100), 'font-weight-bold text-dark');
                                });
                            });
                        }
                    });

                    if (state.discount) {
                        let discount = Math.round(state.discount / 100 * sum_price);
                        ks.group('discount', 'd-flex flex-row', function () {
                            ks.text('Korting (' + state.discount + '%)', 'flex-grow-1');
                            ks.text(euro_fmt.format(-discount / 100), 'font-weight-bold text-dark');
                        });

                        ks.set_next_item_class_name('mt-1 mb-0');
                        ks.separator();

                        ks.text(euro_fmt.format((sum_price - discount) / 100), 'text-right font-weight-bold text-dark mb-2');
                    }

                    ks.group('co2', 'd-flex flex-row', function () {
                        ks.text('CO₂ equivalent', 'flex-grow-1');
                        ks.text(total_co2_formatted(sum_co2) + ' kg', 'font-weight-bold text-success');
                    });

                    if (!pickup) {
                        ks.group('delivery cost', 'alert alert-warning border-0 rounded-0 mx-n3 mt-3', function () {
                            ks.text('Eventuele verzendkosten worden nader bepaald op basis van gemaakte afspraken.');
                        });
                    }

                    ks.separator();

                    ks.text('Prijzen zijn ex. btw', 'text-center text-muted');
                });
            });
        });

        ks.set_next_item_class_name('btn-lg text-nowrap px-4');
        ks.button_container('btn_order', function () {
            if (fetching.submit) {
                ks.spinner('order', 'spinner-border spinner-border-sm align-baseline mr-2');
            } else {
                ks.icon('far fa-chevron-right mr-2');
            }
            ks.text('Bestellen', 'd-inline');
        }).disabled = fetching.submit;
        ks.is_item_clicked(function () {
            ks.submit_form(form);
            ks.refresh();
        });
    } else {
        ks.icon('fal fa-box-open d-block text-center text-primary mt-5').style.fontSize = '3rem';
        ks.h2('Uw winkelwagen is nog leeg.', 'text-primary text-center mb-4');

        ks.group('center', 'd-flex justify-content-center', function () {
            ks.set_next_item_class_name('text-nowrap');
            ks.button_container('Verder winkelen', function () {
                ks.icon('fa fa-chevron-left mr-2');
                ks.text('Verder winkelen', 'd-inline');
            }, 'outline-primary');
            ks.is_item_clicked(function () {
                ks.navigate_to('Home', '/');
            });
        });
    }
}


// [SECTION] BREADCRUMBS
function breadcrumbs(items: string[], proc: (i: number) => void) {
    let current_item = ks.get_current_parent();
    ks.nav('breadcrumb', 'mb-3', function () {
        this.style.fontSize = '0.9rem';
        ks.unordered_list('items', 'breadcrumb bg-white align-items-baseline p-0 m-0', function () {
            ks.list_item('icon', 'breadcrumb-item', function () {
                ks.set_next_item_class_name('text-dark');
                ks.anchor('home', '/', function () {
                    ks.icon('far fa-home align-self-center');
                });
                ks.is_item_clicked(function () {
                    ks.navigate_to('Home', '/');
                    return false;
                });
            });

            for (let i = 0; i < items.length; ++i) {
                if (i + 1 === items.length) {
                    ks.list_item(items[i], 'breadcrumb-item active').setAttribute('aria-current', 'page');
                } else {
                    ks.list_item('locations', 'breadcrumb-item', function () {
                        ks.anchor(items[i], '#');
                        ks.is_item_clicked(function () {
                            proc.call(current_item, i);
                            return false;
                        });
                    });
                }
            }
        });
    }).setAttribute('aria-label', 'breadcrumb');
}


class Page_Section {
    name: string;
    pattern: string;
}

function parse_page_section(parameters: string, sections: Page_Section[], i_fallback = 0) {
    let param_parts = parameters.split('/');
    if (param_parts.length && param_parts[param_parts.length - 1] === '/') {
        param_parts.length = param_parts.length - 1;
    }

    for (let i_section = 0; i_section < sections.length; ++i_section) {
        let section = sections[i_section];
        let pattern = section.pattern;

        if (pattern.length && pattern[0] === '/') {
            console.error('Pattern must not start with /');
        }

        let num_pattern_parts = 1;
        for (let i = 0; i < pattern.length; ++i) {
            if (pattern[i] === '/') {
                num_pattern_parts++;
            }
        }

        if (num_pattern_parts !== param_parts.length) {
            continue;
        }

        let is_match = true;
        let values = null;
        let pattern_parts = pattern.split('/');
        for (let i_part = 0; i_part < pattern_parts.length; ++i_part) {
            let part = pattern_parts[i_part];

            if (part[0] === '{') {
                console.assert(part[part.length - 1] == '}');

                let name: string;
                let type: string;
                let i_colon = part.indexOf(':');
                if (i_colon >= 0) {
                    name = part.substring(1, i_colon);
                    type = part.substring(i_colon + 1, part.length - 1);
                } else {
                    name = part.substring(1, part.length - 1);
                }

                if (type === 'number') {
                    let nr = parseInt(param_parts[i_part]);
                    if (isNaN(nr)) {
                        is_match = false;
                        break;
                    }
                    values = values || Object.create(null);
                    values[name] = nr;
                } else {
                    values = values || Object.create(null);
                    values[name] = param_parts[i_part];
                }
            } else if (part !== param_parts[i_part]) {
                is_match = false;
                break;
            }
        }

        if (is_match) {
            return { name: section.name, values: values, i_section: i_section };
        }
    }

    console.assert(i_fallback < 0 || i_fallback < sections.length);
    return { name: i_fallback < 0 ? '' : sections[i_fallback].name, values: null, i_section: i_fallback };
}


function is_valid_zipcode(zipcode: string) {
    if (zipcode.length !== 6) {
        return false;
    }
    
    for (let i = 0; i < 4; ++i) {
        if (zipcode[i] < '0' || zipcode[i] > '9') {
            return false;
        }
    }
    for (let i = 4; i < 6; ++i) {
        if ((zipcode[i] < 'a' || zipcode[i] > 'z') &&
            (zipcode[i] < 'A' || zipcode[i] > 'Z')) {
            return false;
        }
    }
    return true;
}


function make_url_product(id: number, name: string) {
    return '/p/' + id + '/' + encodeURIComponent(name);
}


class XHR_Reason {
    xhr?: XMLHttpRequest;
    json?: object;
    status?: number;
    in_flight?: boolean;
}

function xhr_get(url: string) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status >= 200 && xhr.status < 300) {
                    try {
                        const json = JSON.parse(xhr.response);
                        resolve(json);
                    } catch (error) {
                        resolve(xhr.response);
                    }
                } else {
                    let reason = new XHR_Reason();
                    reason.xhr = xhr;
                    reason.status = xhr.status;
                    try {
                        reason.json = JSON.parse(xhr.response);
                        reject(reason);
                    } catch (error) {
                        reject(reason);
                    }
                }
            }
        };
        xhr.send();
    });
}

function xhr_get_once(id: string, url: string) {
    let fetching = ks.local_persist(id, { b: false });
    if (!fetching.b) {
        fetching.b = true;
        return xhr_get(url).finally(() => fetching.b = false);
    }
    let reason = new XHR_Reason();
    reason.in_flight = true;
    return Promise.reject(reason);
}

function xhr_send(method: 'GET' | 'POST' | 'PUT' | 'DELETE', url: string, val?) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open(method, url, true);
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status >= 200 && xhr.status < 300) {
                    try {
                        const json = JSON.parse(xhr.response);
                        resolve(json);
                    } catch (error) {
                        resolve(xhr.response);
                    }
                } else {
                    let reason = new XHR_Reason();
                    reason.xhr = xhr;
                    reason.status = xhr.status;
                    try {
                        reason.json = JSON.parse(xhr.response);
                        reject(reason);
                    } catch (error) {
                        reject(reason);
                    }
                }
            }
        };
        if (val instanceof FormData) {
            xhr.send(val);
        } else if (typeof val === 'object') {
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.send(JSON.stringify(val));
        } else {
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.send(val);
        }
    });
}

function xhr_send_once(id: string, method: 'GET' | 'POST' | 'PUT' | 'DELETE', url: string, val?) {
    let fetching = ks.local_persist(id, { b: false });
    if (!fetching.b) {
        fetching.b = true;
        return xhr_send(method, url, val).finally(() => fetching.b = false);
    }
    let reason = new XHR_Reason();
    reason.in_flight = true;
    return Promise.reject(reason);
}

// Obfuscated email combiner
function o_e_combine(pre: string): string {
    let a = 2 * 10 + 3 * 9 + 5 * 6 - 13;
    let d = 3 * 6 + 4 * 5 + 12 - 4;
    return pre + String.fromCharCode(a) + 're-use' + String.fromCharCode(d) + atob('bmw=');
}